import {TweenMax, Linear} from 'gsap';
import {mapState} from 'vuex';
const Vue = require('vue');
const SplitText = require('../../../../viscomjs/utils/SplitText');
const elementsTracking = require('../../../../viscomjs/analytics/elementsTracking');

Vue.component('app-nav', {
    props: {
        map: Object,
        selectedid: String,
        timeoutduration: Number
    },
    template: require('../../../../../../templates/app-nav.pug'),
    data() {
        return {
            hoverId: null,
            outlinedId: null,
            outlinedProgress: 0,
            transition: 0
        };
    },
    mounted() {
        SplitText.wrapSymbols([...this.$el.querySelectorAll('.anim-mask-symbols')], {
            cssProperty: 'transition',
            factor: 1,
            durationRatio: 0.4,
            nestingNum: 2,
            timingNestingLevel: 1
        });

        this.startAnalytics();
    },
    beforeDestroy() {
        this.destroyAnalytics();
    },
    computed: {
        ...mapState('menu', {
            openState: state => state.open,
            openClass: state => (state.open ? 'active' : ''),
            selectedId: state => state.selectedId || ''
        })
    },
    watch: {
        openState(to/* , from*/) {
            // Reset when closed:
            if (!to) {
                this.endOutline(this.outlinedId);
                TweenMax.killTweensOf(this);
            }
            this.transitionStart();
            TweenMax.delayedCall(1.1, this.transitionEnd, [], this);
        }
    },
    methods: {
        // On hover
        hover(id) {
            if (!this.openState || id === this.selectedId) return;
            if (id === this.hoverId) return;
            this.hoverId = id;
        },

        // On out
        out(id) {
            if (id !== this.hoverId) return;
            this.hoverId = null;
        },

        // On hover
        // Temp: on down
        startOutline(id) {
            if (!this.openState || id === this.selectedId) return;
            if (id === this.outlinedId) return;
            this.outlinedId = id;
            this.outlinedProgress = 0;

            TweenMax.to(this, this.timeoutduration, {
                ease: Linear.easeInOut,
                outlinedProgress: 1,
                onComplete: this.selectOutlined,
                onCompleteParams: this
            });
        },

        // On out
        // Temp: on up
        endOutline(id) {
            if (id !== this.outlinedId) return;
            this.outlinedId = null;
            this.outlinedProgress = 0;
            TweenMax.killTweensOf(this);
        },

        // Router action
        selectOutlined(id) {
            if (!this.outlinedId && !id) return;
            this.$router.push({name: 'dynasty', params: {id: id || this.outlinedId}});
        },

        transitionStart() {
            this.transition = 1;
        },

        transitionEnd() {
            this.transition = 0;
        },
        startAnalytics() {
            elementsTracking.init(this.$el);
        },
        destroyAnalytics() {
            elementsTracking.destroy(this.$el);
        }
    }
});
